// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useParams, useHistory } from 'react-router-dom';
import { Container, Card, CardHeader, CardBody, Row, Col, Form, Button } from 'reactstrap';
import { Form as FinalForm } from 'react-final-form';
import { withFormUtils } from '../../hoc/withFormUtils';
import FormFieldTranslations from '../../components/formFields/FormFieldTranslations';
import { generateTranslationKey } from '../../utils/components';
import useFetch from '../../hooks/useFetch';
import { useIntl } from 'react-intl';
import { getRole, updateRole, deleteRole } from '../../redux/methods/permissions';
import { getT } from '../../utils';

/**
 * @typedef {object} RoleEditProps
 * @property {import('../../hoc/withFormUtils').FormUtils} utils
 * @property {(payload: any) => Promise<any>|any} [updateRole]
 * @property {(id: number|string) => Promise<any>|any} [deleteRole]
 */

function RoleEdit({ utils, updateRole, deleteRole, getRole, forceRefetch })
{
    const intl = useIntl();
    const t = getT(intl.messages.permissions);
    const { roleId } = useParams();
    const history = useHistory();
    const [data] = useFetch(getRole, roleId, [roleId], forceRefetch);
    const currentIso = utils.currentLanguage();
    const translationsConfig = { translations: ['name'] };

    const handleSubmitForm = async (formData) =>
    {
        const nameKey = generateTranslationKey('name', currentIso);
        const submit = utils.generateFormToSubmitValues(formData, translationsConfig);
        const nameTranslations = Array.isArray(submit?.name) ? submit.name : [];
         const primaryName =
            formData?.[nameKey]
            || nameTranslations.find(t => t.iso === currentIso)?.value
            || nameTranslations[0]?.value
            || '';
        const payload =
        {
            id: Number(roleId),
            name: primaryName,
            nameTranslations
        };
        await updateRole?.(payload);
        // if (Number(roleId) === 0) {
        //     history.push('/dashboard/roles');
        // }
    };

    const handleDelete = async () =>
    {
        if (window.confirm(t('Are you sure you want to delete this role?')))
        {
            await deleteRole?.(Number(roleId));
            history.push('/dashboard/roles');
        }
    };

    const isRoleNew = Number(roleId) === 0;
    const labelSave = isRoleNew ? t("Create Role") : t("Save Changes");

    return (
        <Container fluid>
            <Card>
                <CardHeader>{t("Role Edit")}</CardHeader>
                <CardBody>
                    <FinalForm
                        key={`roleEdit-${utils.currentLanguage()}`}
                        initialValues={() => {
                            const base = data || {};
                            // eslint-disable-next-line no-undefined
                            const safe = Array.isArray(base.name) ? base : { ...base, name: undefined };
                            const initial = utils.generateFormInitialValues(safe, translationsConfig);
                            // If backend returned a plain string, prefill current locale field
                            if (!Array.isArray(base.name) && typeof base.name === 'string') {
                                const key = generateTranslationKey('name', currentIso);
                                initial[key] = base.name || '';
                            }
                            return initial;
                        }}
                        onSubmit={handleSubmitForm}
                        render={({ handleSubmit, form }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Col md={8}>
                                        <FormFieldTranslations
                                            form={form}
                                            propertyName="name"
                                            label={t("Role Name (translations)")}
                                            currentIso={utils.currentLanguage()}
                                            modalHeader={t("Role Name")}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-5">
                                    <Col md={8} className='d-flex justify-content-between'>
                                        {!isRoleNew && <Button color="danger" type="button" className="ms-2" onClick={handleDelete}>
                                            {t("Delete")}
                                        </Button>}
                                        <Button color="success" type="submit">{labelSave}</Button>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    />
                </CardBody>
            </Card>
    </Container>
    );
}

RoleEdit.propTypes =
{
    utils: PropTypes.object.isRequired,
    role: PropTypes.object,
    updateRole: PropTypes.func,
    deleteRole: PropTypes.func,
    getRole: PropTypes.func,
    forceRefetch: PropTypes.bool,
};

const mapStateToProps = () => (
{
    // eslint-disable-next-line no-undefined
    forceRefetch: undefined,
});

const mapDispatch = { getRole, updateRole, deleteRole };

export default withFormUtils(connect(mapStateToProps, mapDispatch)(RoleEdit));